import { api } from './client';

export const dashboardApi = {
  obter: () => api.get('/dashboard')
};
